import contactImg from "../../assets/backgrounds/banner-lienhe.jpg";

const Contacts = () => {
  return (
    <div className="contacts-page">
      <section className="contacts-section">
        <div className="container contacts-content">
          <div className="contacts-banner">
            <img
              src={contactImg}
              alt="Contact Banner"
              className="contacts-img-banner"
            />
            <h3 className="contacts-banner-title">Liên hệ</h3>
          </div>

          <div className="contacts-detail">
            <div className="general-contact">
              <h3>Liên hệ chung</h3>
              <p className="text-conact-p">
                Nếu bạn có bất kỳ câu hỏi nào hoặc cần thêm thông tin, hãy liên
                hệ chúng tôi:
              </p>
              <p className="text-conact-p">
                Sản phẩm, dịch vụ và tư vấn khoản vay:
              </p>
              <ul>
                <li className="text-contact-li">
                  Hotline: <span className="text-color">024 8588 6168</span>{" "}
                  (sản phẩm Tiền mặt)
                </li>
                <li className="text-contact-li">
                  Hoặc: <span className="text-color">024 8588 6168</span> (sản
                  phẩm Thẻ )
                </li>
                <li className="text-contact-li">
                  Hoặc: <span className="text-color">024 8588 6168</span> (sản
                  phẩm khác)
                </li>
                <li className="text-contact-li">
                  Email:{" "}
                  <span className="text-color">info@hitechvietnam.vn</span>
                </li>
              </ul>
            </div>

            <div className="receiving-channel">
              <h3>Các kênh tiếp nhận góp ý, phản ánh, khiếu nại</h3>
              <p className="text-conact-p">
                Nếu có ý kiến đóng góp, phản ánh hoặc khiếu nại về chất lượng
                dịch vụ, Quý khách có thể liên hệ tổng đài Blue-zone qua các
                kênh liên lạc như sau:
              </p>
              <ul>
                <li className="text-contact-li">
                  1. Ứng dụng{" "}
                  <span className="text-color">
                    Blue-zone - Tài chính Online
                  </span>
                  ;
                </li>
                <li className="text-contact-li">
                  2. Địa chỉ thư điện tử{" "}
                  <span className="text-color">info@hitechvietnam.vn</span>;
                </li>
                <li className="text-contact-li">
                  3. Hotline: <span className="text-color">024 8588 6168</span>{" "}
                  (sản phẩm Thẻ và Vay) hoặc{" "}
                  <span className="text-color">024 8588 6168</span> (sản phẩm
                  khác);
                </li>
                <li className="text-contact-li">
                  4. Gửi thư về cho Phòng chăm sóc khách hàng Công ty Cổ phần
                  Phát triển Hi-Tech Việt Nam địa chỉ nhận thư: <br />
                  <strong>
                    Số 10, ngõ 6A, phố Thành Công, Phường Giảng Võ, TP Hà Nội,
                    Việt Nam
                  </strong>
                </li>
              </ul>
            </div>

            <div className="receive-information">
              <h3>Tra cứu và thay đổi phương thức nhận thông tin quảng cáo</h3>
              <p className="text-conact-p">
                Để bảo đảm an toàn thông tin của Quý khách, vui lòng đăng nhập
                bằng chính tài khoản của Quý khách để thực hiện tra cứu và thay
                đổi yêu cầu tại đây hoặc trên website Blue-zone.
              </p>
              <p className="text-conact-p">
                Bằng việc liên hệ với tổng đài Blue-zone, bạn đồng ý rằng một số
                thông tin cá nhân của bạn có thể được sử dụng cho mục đích cá
                nhân hóa trải nghiệm và làm thông tin liên lạc. Việc sử dụng sẽ
                tuân thủ Chính sách về Bảo vệ dữ liệu và Quyền riêng tư của
                Blue-zone.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contacts;
